const STORAGE_KEY = "pnx:preview";

function detectPreviewMode(): boolean {
  const params = new URLSearchParams(window.location.search);
  const paramValue = params.get("preview");

  if (paramValue === "true") {
    sessionStorage.setItem(STORAGE_KEY, "true");
    return true;
  }
  if (paramValue === "false") {
    sessionStorage.removeItem(STORAGE_KEY);
    return false;
  }
  if (sessionStorage.getItem(STORAGE_KEY) === "true") {
    return true;
  }
  return window.location.hostname.startsWith("preview.");
}

const previewMode = detectPreviewMode();

function derivePreviewUrl(liveUrl: string): string {
  const url = new URL(liveUrl);
  url.hostname = `preview.${url.hostname}`;
  return url.toString();
}

export function isPreviewMode(): boolean {
  return previewMode;
}

export function getBackendUrl(): string {
  const liveUrl = import.meta.env.VITE_PNX_BACKURL;
  return previewMode ? derivePreviewUrl(liveUrl) : liveUrl;
}
